const decodeBase64String = (encodedString: string) => {
  const IS_SERVER = typeof window === 'undefined';

  return IS_SERVER
    ? Buffer.from(encodedString, 'base64').toString()
    : window.atob(encodedString);
};

export { decodeBase64String };
